import $ from "jquery";
import Glide from "@glidejs/glide";
$(document).ready(function () {
    if ($('.carouselWrapper').length) {
        $('.carouselWrapper').each(function (k, e) {
            var gap = $(e).attr("data-gap") !== void 0 ? $(e).attr("data-gap") : 50;
            var mobileGap = $(e).attr("data-mobile-gap") !== void 0 ? $(e).attr("data-mobile-gap") : 20;
            var view = $(e).attr("data-view") !== void 0 ? $(e).attr("data-view") : 2.5;
            var mobileView = $(e).attr("data-mobile-view") !== void 0 ? $(e).attr("data-mobile-view") : 1.3;
            var type = $(e).attr("data-type") !== void 0 ? $(e).attr("data-type") : "slider";
            var focus = $(e).attr("data-focus") !== void 0 ? $(e).attr("data-focus") : 0;
            var bound = $(e).attr("data-bound") !== void 0 ? $(e).attr("data-bound") : false;
            var lgGap = $(e).attr("data-lg-gap") !== void 0 ? $(e).attr("data-lg-gap") : gap;
            var lgView = $(e).attr("data-lg-view") !== void 0 ? $(e).attr("data-lg-view") : view;
            var mdGap = $(e).attr("data-md-gap") !== void 0 ? $(e).attr("data-md-gap") : lgGap;
            var mdView = $(e).attr("data-md-view") !== void 0 ? $(e).attr("data-md-view") : lgView;
            var smGap = $(e).attr("data-sm-gap") !== void 0 ? $(e).attr("data-sm-gap") : mdGap;
            var smView = $(e).attr("data-sm-view") !== void 0 ? $(e).attr("data-sm-view") : mdView;
            var glide = new Glide(e, {
                type: type,
                focusAt: focus,
                perView: view,
                gap: gap,
                startAt: 0,
                bound: true,
                peek: 30,
                breakpoints: {
                    1220: {
                        gap: lgGap,
                        perView: lgView
                    },
                    1050: {
                        gap: mdGap,
                        perView: mdView
                    },
                    768: {
                        gap: smGap,
                        perView: smView
                    },
                    568: {
                        focusAt: "center",
                        gap: mobileGap,
                        perView: mobileView
                    }
                }
            });
            glide.mount();
        });
    }
});
